import Clickable from '@carvana/merch-components/Clickable';
import { motion, AnimatePresence } from 'motion/react';
import { useState } from 'react';
import Modal from '@/common/Modal';
import { imageUrl } from '@/vm/Shared/imageUrl';
import { ReturnPolicyModalWrapper, P } from './ReturnPolicyModal.styles';

type OwnProps = {
  isOpen: boolean;
  onClose: () => void;
};

export default function ReturnPolicyModal({ onClose, isOpen }: OwnProps) {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

  function toggleShowTerms() {
    setIsCollapsed(!isCollapsed);
  }

  function hideTerms() {
    setIsCollapsed(true);
  }

  function toggleModal() {
    hideTerms();
    onClose();
  }

  return (
    <Modal
      whiteBg
      onToggle={() => toggleModal()}
      isLargeModal
      open={isOpen}
      headerText="7-DAY RETURN POLICY"
      id="return-policy-modal"
    >
      <ReturnPolicyModalWrapper>
        <img
          src={imageUrl('7day-icon-lg.png')}
          alt="Seven day money back guarantee"
          className="mx-auto mb-20 block"
        />
        <P>
          Unlike a traditional dealership, when you receive your Carvana car,
          you get to actually live with it for 7 days. Take it on the freeway,
          see how it fits in your garage, and how you can maneuver it into a
          parking space at the grocery store. Does the trunk fit your child’s
          stroller or your golf clubs? If you have a trusted mechanic and want
          an outside opinion, feel free to take it in for an inspection.
        </P>

        <P>
          There is no fee to return or exchange a vehicle for customers in our
          local markets. If you are outside of a local market, you will be
          refunded the price you paid for the vehicle, excluding the delivery
          fee.
        </P>

        <AnimatePresence initial={false}>
          {!isCollapsed && (
            <motion.div
              initial={{ height: 0 }}
              animate={{ height: 'auto' }}
              exit={{ height: 0 }}
              transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }}
              style={{ overflow: 'hidden' }}
            >
              <P className="md:tl-body-s">
                There are a few limits surrounding our 7-day Money Back
                Guarantee. The first day of your test-own period starts on the
                day that you receive the vehicle. If you decide to return your
                vehicle, please let us know prior to 5 p.m. EST on the 7th
                calendar day after receiving it. We will make arrangements with
                you to coordinate the return at that time. Additionally, you can
                drive the vehicle up to 400 miles during your 7-day test-own
                period. You can still return the car if it’s driven over 400
                miles, however, for every additional mile after the 400-mile
                limit, we will charge you a fee of $1.00 per mile. Please note,
                we cannot accept a return where the car has been modified,
                damaged, or altered from its original condition when we
                delivered it to you. We also cannot accept a return if the car
                has been in an accident or has had a lien or other encumbrance
                put on the vehicle (other than the retail installment contract
                you signed with Carvana).
              </P>
            </motion.div>
          )}
        </AnimatePresence>

        <Clickable
          className="text-blue-2 tl-label-m"
          data-analytics-id={
            isCollapsed ? 'TERMS & CONDITIONS' : 'HIDE TERMS & CONDITIONS'
          }
          onClick={toggleShowTerms}
          data-testid="toggle-terms"
        >
          {isCollapsed ? 'TERMS & CONDITIONS' : 'HIDE TERMS & CONDITIONS'}
        </Clickable>
      </ReturnPolicyModalWrapper>
    </Modal>
  );
}
